












import { defineComponent } from '@nuxtjs/composition-api';
import VaimoTruncatedText from 'atoms/VaimoTruncatedText.vue';

import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'CategoryDescription',
  components: {
    VaimoTruncatedText,
    SkeletonLoader
  },
  props: {
    description: {
      type: String,
      default: ''
    }
  }
});
